export default function TimeDropdownIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 3.5C8.25 3.08579 7.91421 2.75 7.5 2.75C7.08579 2.75 6.75 3.08579 6.75 3.5H8.25ZM7.5 7H6.75C6.75 7.41421 7.08579 7.75 7.5 7.75V7ZM11 7.75C11.4142 7.75 11.75 7.41421 11.75 7C11.75 6.58579 11.4142 6.25 11 6.25V7.75ZM13.5 7H12.75C12.75 9.8995 10.3995 12.25 7.5 12.25V13V13.75C11.2279 13.75 14.25 10.7279 14.25 7H13.5ZM7.5 13V12.25C4.60051 12.25 2.25 9.8995 2.25 7H1.5H0.75C0.75 10.7279 3.77208 13.75 7.5 13.75V13ZM1.5 7H2.25C2.25 4.10051 4.60051 1.75 7.5 1.75V1V0.25C3.77208 0.25 0.75 3.27208 0.75 7H1.5ZM7.5 1V1.75C10.3995 1.75 12.75 4.10051 12.75 7H13.5H14.25C14.25 3.27208 11.2279 0.25 7.5 0.25V1ZM7.5 3.5H6.75V7H7.5H8.25V3.5H7.5ZM7.5 7V7.75H11V7V6.25H7.5V7Z"
        fill="currentColor"
      />
    </svg>
  );
}
